// extracted by mini-css-extract-plugin
export default {"container":"styles_container__39R4+","image":"styles_image__3w3+v","item":"styles_item__CsvQr","projects":"styles_projects__bqgwg"};